import { render, staticRenderFns } from "./provision-general.vue?vue&type=template&id=54c115a8&scoped=true&"
import script from "./provision-general.vue?vue&type=script&lang=js&"
export * from "./provision-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c115a8",
  null
  
)

export default component.exports